import * as React from 'react';
import {useState} from 'react';
import {config, Spring, AnimationProps} from 'react-spring';

interface OwnProps {
  springConfig: AnimationProps['config'];
  children: React.ReactNode;
}

type Props = OwnProps;

export const AnimatedButton: React.FC<Props> = (props) => {
  const {children, springConfig = config.gentle} = props;

  const [clicked, setClicked] = useState<boolean>(false);

  const handleAnimatedButtonClick = () => {
    setClicked(!clicked);
  };

  return (
    <Spring
      from={{transformScaleValue: -1}}
      to={{transformScaleValue: clicked ? 1 : -1}}
      config={springConfig}
    >
      {({transformScaleValue}) => {
        const childsWithProps = React.Children.map(
          children,
          // TODO: should render element wrapped with "animated" from react-spring
          (child) => {
            let returnValue;
            if (React.isValidElement(child) && transformScaleValue) {
              returnValue = React.cloneElement(child, {
                handleAnimatedButtonClick,
                transformScaleValue,
              });
            }
            return returnValue;
          }
        );

        return <span>{childsWithProps}</span>;
      }}
    </Spring>
  );
};

AnimatedButton.displayName = 'AnimatedButton';
